import { createSvgIconComponent } from "../utils";

export const IconAlert = createSvgIconComponent({
  viewBox: "0 0 20 20",
  fillRule: "evenodd",
  clipRule: "evenodd",
  path: "M10 18a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm1.302-8.676a1.188 1.188 0 01-2.369-.042l-.331-5.567a1.62 1.62 0 113.229.058l-.529 5.551zM10 13.6a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z",
});
